import { Pipe, PipeTransform } from '@angular/core';
import { KeyValueI } from '../../models/common';
import { AccountsMapper, OrderTableColumNameMapper, QuotesTableColumNameMapper, ArtworkMapper,ProductsMapper,  ProductionMapper, LeadsMapper, OpportunitiesMapper, ContactsMapper} from '../../models/Orders/order-list';

@Pipe({
  name: 'orderColumnNameMapper'
})
export class OrderColumnNameMapperPipe implements PipeTransform {

  public transform(value: string,page: string, mappingFields: any ): string {
    let foundValue;
    if(mappingFields) {
      foundValue = mappingFields.find((field: any) => field.fieldName === value.trim());
    }
    if(!foundValue || foundValue.labelName == '') {
      if(page === 'Quotes'){
        foundValue = QuotesTableColumNameMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if(page === 'Orders') {
        foundValue = OrderTableColumNameMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Accounts'){
        foundValue = AccountsMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Artwork'){
        foundValue = ArtworkMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Products'){
        foundValue = ProductsMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Production'){
        foundValue = ProductionMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Leads'){
        foundValue = LeadsMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Opportunities'){
        foundValue = OpportunitiesMapper.find((col: KeyValueI) => col.key === value.trim());
      } else if (page === 'Contacts'){
        foundValue = ContactsMapper.find((col: KeyValueI) => col.key === value.trim());
      }
      if(foundValue)
        return foundValue.value;
    } else {
      if(foundValue)
        return foundValue.labelName;
    }
    
    return value;
  }

}
